import React from 'react';
import PropTypes from 'prop-types';

// Components
import GasSectionCard from '../GasSectionCard/GasSectionCard';
import Grid from './components/Grid';

// Lib
import hasSectionContent from '../../lib/hasSectionContent.lib.gas';

const GasSectionsGrid = ({sections = [], gas}) => (
  <Grid>
    {sections
      .filter((section) => hasSectionContent(section, gas))
      .map((section) => (
        <GasSectionCard key={section.key} section={section} gas={gas} />
      ))}
  </Grid>
);

GasSectionsGrid.propTypes = {
  sections: PropTypes.array,
  gas: PropTypes.object,
};

export default GasSectionsGrid;
